import CampaignsView from "@extension/context/content/components/bt-bulk-dashboard/campaigns-view";
import { Stack } from "@mui/material";
import AppView from "../../components/app-view";
import classes from "../account-view/account-view.module.scss";
import BoardsPanel from "../boards-panel/BoardsPanel";
import ConnectedEngines from "@common/components/connected-engines/connected-engines";
import QrModal from "@common/views/qr-view/qr-modal";
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';
import { useAppSelector } from "@common-reducers/hooks/store.hook";

const LaunchCampaignView = () => {
  const { t } = useTranslation(namespace);
  const activeBulkView = useAppSelector((state) => state.CampaignReducer.activeBulkView);

  // Hide header when in internal views (board view, template edit/new, campaign logs)
  const shouldShowHeader = !(
    activeBulkView === "campaignBoardFromManagementView" ||
    activeBulkView === "campaignBoardFromNewCampaignView" ||
    activeBulkView === "campaignNewTemplateViewFromManagement" ||
    activeBulkView === "campaignNewTemplateViewFromNewCampaignView" ||
    activeBulkView === "campaignNewTemplateViewFromWhatsappView" ||
    activeBulkView === "campaignLogsView"
  );

  return (
    <>
      <AppView title={t('campaign.title')} activeExtensionView="campaigns" showHeader={shouldShowHeader}>
        <CampaignsView isWebsite={true} />
      </AppView>
      <QrModal />
    </>
  );
};

export default LaunchCampaignView;
